<template>
  <header class="o-header" :style="{ height: `${headHeight}px`  }">
    <my-headroom class="o-header__inner" ref="fixedHead">
      <div class="o-header__top-row">
        <div class="o-container">
          <div class="o-header__top">
            <!-- Branding -->
            <h1 class="o-header__title"><router-link to="/" class="o-header__logo"><span class="u-hide">UK Power Networks</span></router-link></h1>

            <!-- Mobile tools -->
            <div class="o-header__mobile" v-if="isMobileMenu">
              <a class="c-mobile-btn" :href="`mailto:${$globals.contact}`">
                <span class="c-mobile-btn__icon"><svg class="c-icon c-icon--envelop3"><use xlink:href="#icon-envelop3"></use></svg></span>
                <span class="c-mobile-btn__text">Feedback</span>
              </a>
              <button class="c-mobile-btn" @click="$store.commit('setDownload')">
                <span class="c-mobile-btn__icon"><svg class="c-icon c-icon--download"><use xlink:href="#icon-download"></use></svg></span>
                <span class="c-mobile-btn__text">Downloads</span>
              </button>
              <button class="c-mobile-btn" @click="$store.commit('setMenu')">
                <span class="c-mobile-btn__icon"><svg class="c-icon c-icon--bars"><use xlink:href="#icon-bars"></use></svg></span>
                <span class="c-mobile-btn__text">Menu</span>
              </button>
            </div>

            <!-- Desktop -->
            <div class="o-header__desktop" v-if="!isMobileMenu">
              <div class="o-header__tools">
                <a class="o-header__desktop-download c-download-btn" :href="`mailto:${$globals.contact}`">
                  <span class="c-download-btn__icon"><svg class="c-icon c-icon--envelop3"><use xlink:href="#icon-envelop3"></use></svg></span>
                  <span class="c-download-btn__text">Feedback</span>
                </a>
                <button class="o-header__desktop-download c-download-btn" @click="$store.commit('setDownload')">
                  <span class="c-download-btn__icon"><svg class="c-icon c-icon--download"><use xlink:href="#icon-download"></use></svg></span>
                  <span class="c-download-btn__text">Downloads</span>
                </button>
              </div>

              <my-menu class="o-header__menu o-menu--desktop" :primary-only="true"></my-menu>
            </div>
          </div>
        </div>
      </div>

      <!-- Sub menu -->
      <div class="o-header__bottom" v-if="subPages.children && !isMobileMenu && !subPages.parent.shared">
        <div class="o-container">
          <nav class="o-menu o-menu--desktop o-menu--sub">
            <ul class="o-menu__wrap">
              <li class="o-menu__item" v-for="(item, index) in subPages.children" :key="index"><router-link class="o-menu__link" :to="`/${subPages.parent.slug}/${item.slug}`" >{{ item.title }}</router-link></li>
            </ul>
          </nav>
        </div>
      </div>
    </my-headroom>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MyMenu from '@/components/objects/MyMenu'
import MyHeadroom from '@/components/objects/MyHeadroom'
import throttle from 'lodash/throttle'
// import MyScroll from '@/components/objects/MyScroll'

export default {
  name: 'MyHeader',
  components: {
    MyMenu,
    MyHeadroom
  },
  data () {
    return {
      fixedHead: null
    }
  },
  computed: {
    ...mapState(['isMobileMenu', 'headHeight']),
    ...mapGetters({
      subPages: 'getSubPages'
    })
  },
  methods: {
    resized () {
      this.$store.commit('setHeadHeight', this.fixedHead.clientHeight)
    }
  },
  created () {
    this.resizeHandler = throttle(() => this.resized(), 200)
    window.addEventListener('resize', this.resizeHandler)
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeHandler)
  },
  mounted () {
    this.fixedHead = this.$refs.fixedHead.$el
  },
  watch: {
    $route (to, from) {
      this.$nextTick(() => {
        this.$store.commit('setHeadHeight', this.fixedHead.clientHeight)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/objects/MyHeader.vue